import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-chronoblog/src/components/page/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AuthorBanner = makeShortcode("AuthorBanner");
const Tags = makeShortcode("Tags");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AuthorBanner mdxType="AuthorBanner" />
    <p>{`Hi, I'm `}<a parentName="p" {...{
        "href": "./about"
      }}>{`Imron Rosyadi`}</a>{`  `}</p>
    <p>{`I am a associate professor and researcher in `}<a parentName="p" {...{
        "href": "http://elektro.ft.unsoed.ac.id/"
      }}>{`Electrical Engineering`}</a>{`, `}<a parentName="p" {...{
        "href": "http://ft.unsoed.ac.id/"
      }}>{`College of Engineering`}</a>{`, `}<a parentName="p" {...{
        "href": "http://unsoed.ac.id/"
      }}>{`Jenderal Soedirman University`}</a>{`.`}<br parentName="p"></br>{`
`}{`I'm learning, teaching, and researching Machine Learning, Internet of Things, and Control Systems.  `}</p>
    <p>{`For more information, please visit:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://elektro.ft.unsoed.ac.id/imron-rosyadi/"
        }}>{`my university page`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://irosyadi.netlify.app/"
        }}>{`my knowledge base`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://soedirman-machine-learning.github.io/"
        }}>{`Soedirman Machine Learning Research Group`}</a>{`  `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://soedirman-iot.github.io/"
        }}>{`Soedirman Internet of Things Research Group`}</a>{`  `}</li>
    </ul>
    <hr></hr>
    <Tags mdxType="Tags" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      